import { StringUnionKeyAsValue } from '~commonInfra/utils/TypescriptHelpers';

export type CatalogContentType = 'database' | 'table';

export const CatalogContentTypes: StringUnionKeyAsValue<CatalogContentType> = {
  database: 'database',
  table: 'table',
};
